import dotenv from 'dotenv';
import CryptoJS from 'crypto-js';
import cloneDeep from 'lodash/cloneDeep';
import axios from 'axios';
import { Auth } from 'aws-amplify';
import swal from '@sweetalert/with-react';
import { CountryList } from '../common/CountryList';
dotenv.config();
const moment = require('moment');

export const EVENT_ID = 'evt120';
export const EVENT_CODE = 'PRS#2022';
export const EVENT_NAME = 'PRS2022';
export const EVENT_IMG = '/images/PRS2022';
export const EVENT_DAYS = ['20221111', '20221112', '20221113'];

export const CHANNEL = ['Room1', 'Room2', 'Room3', 'Room4', 'Room5', 'Faculty Room'];
export const CHANNEL_DP = ['Room 1', 'Room 2', 'Room 3', 'Room 4', 'Room 5', 'Faculty Room'];
export const COMMON_IMG = '/images/common';
export const F_EMAIL = 'PRS KOREA 2022 <secretariat.kprs@innon.co.kr>';
// 아래 index는 기능별로 확인 후 수정
export const WELCOME_TEMPLATE = 'WelcomePRS2021';
export const FINDPWD_TEMPLATE = 'FindPwdPRS2022';
export const PAPERSUBMIT_TEMPLATE = 'PaperSubmitPRS2022';

export const REGISTRAIONSUBMIT_TEMPLATE = 'RegistrationSubmitPRS2021';
export const PAYCOMPLETE_TEMPLATE = 'PayCompletePRS2021';

export const SPEAKERSUBMIT_TEMPLATE = 'SpeakerSubmitPRS2021';
export const SPONSORSUBMIT_TEMPLATE = 'SponsorSubmitPRS2021';

export const PAPERACCEPT_TEMPLATE = 'AcceptPRS2021';
export const PAPERGUIDE_TEMPLATE = 'GuidelinePRS2021';
// export const BCC_ADDR_EMAIL = ['hjkang@atozsoft.co.kr', 'jhshin@innon.co.kr', 'secretariat.kprs@innon.co.kr'];
export const BCC_ADDR_EMAIL = ['rasborafive@gmail.com'];
// sign-up, registration, sponsor 접수 완료 시 받는 이메일주소
export const BCC_ADDR_EMAIL_REG = ['secretariat.kprs@innon.co.kr'];

// free paper, speaker abstract 접수 완료 시 받는 이메일주소 - 미사용
export const BCC_ADDR_EMAIL_PAPER = ['ademic.kprs@innon.co.kr'];

export const EVENTS_API_URL = 'https://ocpxoadfl8.execute-api.ap-northeast-2.amazonaws.com/latest';
export const PROGRAM_URL = 'https://2ecuzxhg64.execute-api.ap-northeast-2.amazonaws.com/latest';
export const PG_API_URL = 'https://58c2iafzj6.execute-api.ap-northeast-2.amazonaws.com/latest';
export const WEB_API = 'https://md4ups5iql.execute-api.ap-northeast-2.amazonaws.com/latest';
export const FACULTY_API_URL = 'https://t42kdymslk.execute-api.ap-northeast-2.amazonaws.com/latest';
export const WEBSOCKET_URL = 'wss://64au02hcs1.execute-api.ap-northeast-2.amazonaws.com/Prod';
export const PROGRAM_API_URL = 'https://2ecuzxhg64.execute-api.ap-northeast-2.amazonaws.com/latest';

// [PG] Eximbay 설정

// for TEST
// export const EXIMBAY_SECRETKEY = '289F40E6640124B2628640168C3C5464'; //테스트용 가맹점용
// export const EXIMBAY_MID = '1849705C64'; // 테스트용

// for REAL
export const EXIMBAY_SECRETKEY = '2F2143AD54031AAF574E5FA4178B9346';
export const EXIMBAY_MID = '491A10DF1C';

export const EXIMBAY_PAY = PG_API_URL + '/eximbay/';
export const EXIMBAY_CALLBACK = PG_API_URL + '/eximbay/callback';
export const EXIMBAY_STATUS_CALLBACK = PG_API_URL + '/eximbay/callback';

// [PG] Kicc 설정

// for TEST
// export const KICC_MID = 'T0001997'; //05109440
// export const KICC_PAY = 'https://testpgapi.easypay.co.kr/api/trades/webpay';
// export const KICC_APPROVAL = 'https://testpgapi.easypay.co.kr/api/trades/approval';

// for REAL
export const KICC_MID = '05109440'; //05109440
export const KICC_PAY = 'https://pgapi.easypay.co.kr/api/trades/webpay';
export const KICC_APPROVAL = 'https://pgapi.easypay.co.kr/api/trades/approval';

// [PG] 공통
// 1. 열려있는 로컬 포트 번호 적용하여 테스트.
// 2. 빌드 시 행사 사이트로 변경.

export const PG_REDIRECT = 'https://www.prskorea.org/#/payResult';
// export const PG_REDIRECT = 'http://localhost:3000/#/payResult';

export const KR_MOBILE_REG = /^01(?:0|1|[6-9])(?:\d{3}|\d{4})(\d{4})$/;
// eslint-disable-next-line
export const EMAIL_REG = /^([-_\.0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;

export const getEventId = () => {
  return EVENT_ID;
};

export const encrypt = (str) => {
  const hash = CryptoJS.MD5(str);
  const key = CryptoJS.enc.Utf8.parse(hash); // hex로 변환
  return CryptoJS.enc.Base64.stringify(key);
};

export const decrypt = (str) => {
  const decrypt = CryptoJS.enc.Base64.parse(str);
  return decrypt.toString(CryptoJS.enc.Utf8);
};

export const encryptAES = (str) => {
  return CryptoJS.AES.encrypt(str, EVENT_CODE);
};

export const decryptAES = (str) => {
  const dc = CryptoJS.AES.decrypt(str, EVENT_CODE);
  return dc.toString(CryptoJS.enc.Utf8);
};

export const getUserID = (isPost) => {
  if (isPost) {
    return `${sessionStorage.getItem('_in_user_')}`;
  } else {
    return encodeURIComponent(`${sessionStorage.getItem('_in_user_')}`);
  }
};

export const getEventDays = () => {
  let item = JSON.parse(sessionStorage.getItem('EVENT'));
  if (item) {
    let startDate = item.startDate;
    let endDate = item.endDate;

    startDate = new Date(startDate.substring(0, 4), startDate.substring(4, 6) - 1, startDate.substring(6, 8));
    endDate = new Date(endDate.substring(0, 4), endDate.substring(4, 6) - 1, endDate.substring(6, 8));

    let buffs = [];
    let buffsValue = [];
    let continueDate = startDate;
    while (continueDate.getTime() <= endDate.getTime()) {
      let value =
        continueDate.getFullYear() +
        (continueDate.getMonth() + 1 > 9 ? '' : '0') +
        (continueDate.getMonth() + 1) +
        (continueDate.getDate() > 9 ? '' : '0') +
        continueDate.getDate();

      buffsValue.push(value);
      buffs.push(cloneDeep(continueDate));

      continueDate.setDate(continueDate.getDate() + 1);
    }

    return { _buffs: buffs, _buffsValue: buffsValue };
  } else {
    return { _buffs: [], _buffsValue: [] };
  }
};

export const groupBy = (array, key) => {
  return array.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export const titleCounter = (str) => {
  const wordArr = str.split(' ');
  // console.log(wordArr);
  let buff = [];
  for (let i = 0; i < wordArr.length; i++) {
    if (wordArr[i] !== '' && wordArr[i] !== '&nbsp;' && wordArr[i].length > 0) {
      buff.push(wordArr[i]);
    }
  }
  // // buff = buff.flatMap((b) => b.split(' '));
  // buff = buff.reduce((arr, x) => (arr.push(...x.split(' ')), arr), []);
  // // console.log(buff);
  return buff.length;
};

export const wordCounter = (str) => {
  const wordArr = str.split(/\n/);
  // console.log(wordArr);
  let buff = [];
  for (let i = 0; i < wordArr.length; i++) {
    wordArr[i] = wordArr[i].replace(/(\n)|(\t)|(<\/?(\s|\S)*?>)/gi, '');
    if (
      wordArr[i] !== '' &&
      wordArr[i] !== '&nbsp;' &&
      wordArr[i] !== '\n' &&
      wordArr[i] !== '\n\n' &&
      wordArr[i] !== '\n\n&nbsp;' &&
      wordArr[i].length > 0
    ) {
      buff.push(wordArr[i]);
    }
  }
  // buff = buff.flatMap((b) => b.split(' '));
  // eslint-disable-next-line
  buff = buff.reduce((arr, x) => (arr.push(...x.split(' ')), arr), []);
  // console.log(buff);
  return buff.length;
};

export const paragraphCounter = (str) => {
  const splitArr = str.split(/\n/);
  // const splitArr = str.replace(/(<[^/](\s|\S)*?>)/gi, '').split(/<\/p>|<\/li>|<\/h1>|<\/h2>|<\/h3>|<\/div>/);
  let paragraphArr = [];

  // console.log(splitArr);

  for (let i = 0; i < splitArr.length; i++) {
    splitArr[i] = splitArr[i].replace(/(&nbsp;)|(\n)|(\t)|(<\/?(\s|\S)*?>)/gi, '');
    if (
      splitArr[i] !== '' &&
      splitArr[i] !== '&nbsp;' &&
      splitArr[i] !== '\n' &&
      splitArr[i] !== '\n\n' &&
      splitArr[i] !== '\n\n&nbsp;' &&
      splitArr[i].length > 0
    ) {
      paragraphArr.push(splitArr[i]);
    }
  }
  // console.log(paragraphArr);
  return paragraphArr.length;
};

export const dDayCount = (dateStr) => {
  //dateStr은 'YYYY-MM-DD' 형식으로 넘겨줘야 됨
  const dDay = moment(dateStr);
  const today = moment();
  return dDay.diff(today, 'days');
};

export const readFile = (file, limit) => {
  if (!limit) limit = -1;
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (_read) => {
      if (limit > 0 && _read.total > 1000000 * limit) {
        reject(`File too large : limit ${limit}MB`);
      } else {
        resolve(_read);
      }
    };
  });
};

export const setScrollPosition = (height) => {
  document.getElementById('subroot').scrollTop = height;
};

export const focusElementRef = (msg, ref) => {
  swal(msg).then(() => {
    ref.current.focus();
  });
};

export const emailValidation = (email) => {
  if (EMAIL_REG.test(email)) {
    return true;
  } else {
    return false;
  }
};

export const krMobileValidation = (mobile) => {
  if (KR_MOBILE_REG.test(mobile)) {
    return true;
  } else {
    return false;
  }
};

export const getDialingCode = (countryName) => {
  let code = '';
  CountryList.forEach((country) => {
    if (countryName === country.name) {
      code = country.dialingCode;
    }
  });
  return code;
};

export const addComma = (num) => {
  const regexp = /\B(?=(\d{3})+(?!\d))/g;
  return num.toString().replace(regexp, ',');
};

export const stripHtml = (html) => {
  const temporalDivElement = document.createElement('div');
  temporalDivElement.innerHTML = html;
  return temporalDivElement.textContent || temporalDivElement.innerText || '';
};

export const saveDeadline = (deadline, key) => {
  const updateParam = {
    id: EVENT_ID,
    code: EVENT_CODE,
    [key]: deadline,
  };
  axiosInstance.put(`${WEB_API}/event/`, updateParam).then((response) => {
    axiosInstance
      .get(`${WEB_API}/event/info?eventId=${getEventId()}&code=${encodeURIComponent(EVENT_CODE)}`, {
        headers: { Pragma: 'no-cache' },
      })
      .then((response) => {
        if (response.data.Item) {
          sessionStorage.removeItem('EVENT');
          sessionStorage.setItem('EVENT', JSON.stringify(response.data.Item));
          swal('마감일시를 저장하였습니다.');
        }
      });
  });
};

export const checkDeadline = (key) => {
  const EVT = sessionStorage.getItem('EVENT');
  if (EVT) {
    const deadline = moment(JSON.parse(EVT)[key] + ':59');
    const now = moment();
    // console.log(key, deadline.tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss'));
    // console.log('now', now.tz('Asia/Seoul').format('YYYY-MM-DD HH:mm:ss'));
    // console.log('isDeadline', deadline.isAfter(now.tz('Asia/Seoul')));
    return deadline.isAfter(now.tz('Asia/Seoul'));
  } else {
    return false;
  }
};

const axiosInstance = axios.create({
  baseURL: WEB_API,
  timeout: 3000 * 10,
  headers: { Pragma: 'no-cache', Authorization: `${sessionStorage.getItem('_in_jwt')}` },
});

axiosInstance.interceptors.request.use(
  function (config) {
    // 요청 바로 직전 axios 설정값에 대해 작성합니다.
    config.headers.Authorization = `${sessionStorage.getItem('_in_jwt')}`;
    return config;
  },
  function (error) {
    // 요청 에러 처리를 작성합니다.
    console.log(error.message);
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  function (response) {
    // tokenRefresh().then((r) => {});
    return response;
  },

  function (error) {
    if (error.response) {
      // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // 요청이 이루어 졌으나 응답을 받지 못했습니다.
      // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
      // Node.js의 http.ClientRequest 인스턴스입니다.
      console.log(error.request);
    } else {
      // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
      console.log('Error', error.message);
    }
    console.log(error.config);
    // eslint-disable-next-line
    const orgRequest = error.config;
    if (error.response && error.response.status === 401) {
      console.log('토큰 만료');
      tokenRefresh()
        .then((refreshRes) => {
          // orgRequest.headers['Authorization'] = sessionStorage.getItem('_in_jwt');
          window.location.reload();
          // return Promise.resolve(axios(orgRequest));
        })
        .catch((err) => {
          window.location.href = '/#/signin';
        });
    }
    return Promise.reject(error);
  },
);

export const tokenRefresh = async () => {
  try {
    const cognitoUser = await Auth.currentAuthenticatedUser();
    // console.log(cognitoUser);
    const currentSession = await Auth.currentSession();
    cognitoUser.refreshSession(currentSession.refreshToken, (err, session) => {
      if (session) {
        const { accessToken } = session;
        sessionStorage.setItem('_in_jwt', accessToken.jwtToken);
        return Promise.resolve(accessToken.jwtToken);
      } else {
        console.log(err.message);
      }
    });
  } catch (e) {
    console.log('Unable to refresh Token', e);
  }
};

export default axiosInstance;
